import React from 'react';
import { Card } from '../components/UI/Card';
export const NetworkingGuide = () => {
  const steps = [{
    number: '1️⃣',
    title: 'Set Your Compass – What Do You Want?',
    content: <div className="space-y-4" data-id="element-4156" data-mp="21mcj4ey1p1na">
          <p data-id="element-4157" data-mp="21ndvqnuplw74">Instead of "I must network more," ask:</p>
          <ul className="space-y-2" data-id="element-4158" data-mp="1xl0uocqwqmgo">
            <li className="flex items-start" data-id="element-4159" data-mp="1xm2fh8xq6nbl">
              <span className="mr-2" data-id="element-4160" data-mp="1xndkfc2wq14a">🔍</span>
              <span data-id="element-4161" data-mp="2ua8dve420jhf">What excites me about connecting with others?</span>
            </li>
            <li className="flex items-start" data-id="element-4162" data-mp="2pbx4f4ho8azq">
              <span className="mr-2" data-id="element-4163" data-mp="2pcypm1seidv6">🎯</span>
              <span data-id="element-4164" data-mp="2kkyk7ttkasr7">
                Am I seeking mentorship, collaboration, opportunities, or just
                inspiration?
              </span>
            </li>
            <li className="flex items-start" data-id="element-4165" data-mp="2gi29sqe6e2yc">
              <span className="mr-2" data-id="element-4166" data-mp="3d2t4eowa6ci2">💎</span>
              <span data-id="element-4167" data-mp="3d3vrelqhfusp">What unique value do I bring into a conversation?</span>
            </li>
          </ul>
          <p className="font-medium flex items-start" data-id="element-4168" data-mp="38981ciftysc0">
            <span className="mr-2" data-id="element-4169" data-mp="1yi93oah3n9h">✍️</span>
            <span data-id="element-4170" data-mp="1zjm3yb1ujtu">
              Exercise: Write 3 things you hope to gain from networking — and 3
              things you can give.
            </span>
          </p>
        </div>
  }, {
    number: '2️⃣',
    title: 'Design Your Introduction (Your Story in 30 Seconds)',
    content: <div className="space-y-4" data-id="element-4171" data-mp="3ta1uby44g984">
          <p data-id="element-4172" data-mp="3fcd8amybiw1h">
            Networking starts with clarity. But clarity doesn't mean rigidity.
          </p>
          <ul className="space-y-2" data-id="element-4173" data-mp="3kbpt725mpt1f">
            <li className="flex items-start" data-id="element-4174" data-mp="3kbyad68sbkif">
              <span className="mr-2" data-id="element-4175" data-mp="35dxhym747qt1">👤</span>
              <span data-id="element-4176" data-mp="35f7fnaa22wz5">Who am I? (roles, passions, projects)</span>
            </li>
            <li className="flex items-start" data-id="element-4177" data-mp="3ac7d4wsuaren">
              <span className="mr-2" data-id="element-4178" data-mp="3af39whsyba1i">🌱</span>
              <span data-id="element-4179" data-mp="13mawt19wmq4h">What drives me? (purpose, values, interests)</span>
            </li>
            <li className="flex items-start" data-id="element-4180" data-mp="18ldu1zjn7s1w">
              <span className="mr-2" data-id="element-4181" data-mp="18l41q5b4l8t1">🔗</span>
              <span data-id="element-4182" data-mp="17470qlj8cnn5">Who do I want to connect with right now?</span>
            </li>
          </ul>
          <p className="font-medium flex items-start" data-id="element-4183" data-mp="125nboc9cavqk">
            <span className="mr-2" data-id="element-4184" data-mp="123ssp3hmpdp4">🎤</span>
            <span data-id="element-4185" data-mp="x60yg2tihfhr">
              Activity: Draft 2-3 "micro-intros" you can switch between (for
              events, LinkedIn, casual chats).
            </span>
          </p>
        </div>
  }, {
    number: '3️⃣',
    title: 'Choose Your Arena – Where Will You Play?',
    content: <div className="space-y-4" data-id="element-4186" data-mp="1px2lsr7cyhcd">
          <p data-id="element-4187" data-mp="1kvd7n2ou9nk2">Networking happens everywhere:</p>
          <ul className="space-y-2" data-id="element-4188" data-mp="1kwn5prvoyvqp">
            <li className="flex items-start" data-id="element-4189" data-mp="1g4wrvbxjppuj">
              <span className="mr-2" data-id="element-4190" data-mp="1g3lohd80ik3y">🎙</span>
              <span data-id="element-4191" data-mp="1c3jod8hxdyqs">Events & salons</span>
            </li>
            <li className="flex items-start" data-id="element-4192" data-mp="1c31qk7fm7cgr">
              <span className="mr-2" data-id="element-4193" data-mp="28l7ixftif427">📩</span>
              <span data-id="element-4194" data-mp="28n0qcxby5sb9">DMs & email outreach</span>
            </li>
            <li className="flex items-start" data-id="element-4195" data-mp="23u7k250tybx2">
              <span className="mr-2" data-id="element-4196" data-mp="23tg23x05ocp9">🌍</span>
              <span data-id="element-4197" data-mp="3mi0q0wq5inat">Online communities & forums</span>
            </li>
            <li className="flex items-start" data-id="element-4198" data-mp="3mjtxge8l9bjv">
              <span className="mr-2" data-id="element-4199" data-mp="3rhloz75bmvnj">☕</span>
              <span data-id="element-4200" data-mp="3rioh1iedr451">Coffee chats</span>
            </li>
          </ul>
          <p className="font-medium flex items-start" data-id="element-4201" data-mp="3vhe3e0hebw0t">
            <span className="mr-2" data-id="element-4202" data-mp="4bmef4fcupfl">🧭</span>
            <span data-id="element-4203" data-mp="4cns7gnr9q10">
              Prompt: Where do you already feel most comfortable starting? Where
              do you want to stretch yourself?
            </span>
          </p>
        </div>
  }, {
    number: '4️⃣',
    title: 'Practice the First Move',
    content: <div className="space-y-4" data-id="element-4204" data-mp="j08r0ydll334">
          <p data-id="element-4205" data-mp="j222qs32idhz">Instead of waiting for serendipity, design it.</p>
          <ul className="space-y-2" data-id="element-4206" data-mp="n2vobet1fg7p">
            <li data-id="element-4207" data-mp="n1ubb4sgojnc">
              <strong data-id="element-4208" data-mp="n4gih3bfwx51">Warm path:</strong> Ask someone you know for an intro.
            </li>
            <li data-id="element-4209" data-mp="s39xx1aaey7u">
              <strong data-id="element-4210" data-mp="rzm1nudgjxpf">Curious path:</strong> Reach out with a thoughtful
              question.
            </li>
            <li data-id="element-4211" data-mp="jdt5ne8mwsi0">
              <strong data-id="element-4212" data-mp="jdb0tt7wp5yh">Bold path:</strong> DM someone you admire with a specific
              compliment or idea.
            </li>
          </ul>
          <p className="font-medium flex items-start" data-id="element-4213" data-mp="ee6r91h2l67m">
            <span className="mr-2" data-id="element-4214" data-mp="t45ngyp2e7kg">💡</span>
            <span data-id="element-4215" data-mp="t2um15j3dbwi">
              Challenge: This week, make 2 connections: one warm intro, one bold
              outreach.
            </span>
          </p>
        </div>
  }, {
    number: '5️⃣',
    title: 'Build Trust, Not Just Contacts',
    content: <div className="space-y-4" data-id="element-4216" data-mp="3rli0xi76ndz3">
          <p data-id="element-4217" data-mp="3rmjmwhpqlkvl">Think about conversations as bridges, not transactions.</p>
          <ul className="space-y-2" data-id="element-4218" data-mp="ado1dcyqma82">
            <li className="flex items-start" data-id="element-4219" data-mp="aepmybddqf41">
              <span className="mr-2" data-id="element-4220" data-mp="5ebc6lke8r2b">👂</span>
              <span data-id="element-4221" data-mp="5cgrn8d1b0yr">Listen deeply.</span>
            </li>
            <li className="flex items-start" data-id="element-4222" data-mp="1ls1mwb60qdkx">
              <span className="mr-2" data-id="element-4223" data-mp="1lqqge3l6urq4">🎁</span>
              <span data-id="element-4224" data-mp="1gtgswthd0q4x">
                Offer something of value (resource, insight, connection).
              </span>
            </li>
            <li className="flex items-start" data-id="element-4225" data-mp="1obodzgjua5ub">
              <span className="mr-2" data-id="element-4226" data-mp="1of2his48ol3c">🔄</span>
              <span data-id="element-4227" data-mp="1tcu9fm4vw77j">
                Follow up quickly with gratitude + a simple next step.
              </span>
            </li>
          </ul>
          <p className="font-medium flex items-start" data-id="element-4228" data-mp="1fe4fgfdd2nne">
            <span className="mr-2" data-id="element-4229" data-mp="1jeo9vb6jvd5u">✨</span>
            <span data-id="element-4230" data-mp="1jfpn9mb1gbqq">
              Reflection: Recall the last time someone made you feel heard. How
              can you replicate that in your networking?
            </span>
          </p>
        </div>
  }, {
    number: '6️⃣',
    title: 'Keep the Web Alive',
    content: <div className="space-y-4" data-id="element-4231" data-mp="1ya471p2ffp6g">
          <p data-id="element-4232" data-mp="1y92vzklev2oq">A network is like a garden — it needs tending.</p>
          <ul className="space-y-2" data-id="element-4233" data-mp="22b68mcjtgdbl">
            <li className="flex items-start" data-id="element-4234" data-mp="22a4n1e56c8fm">
              <span className="mr-2" data-id="element-4235" data-mp="2q10korwb9xus">🌱</span>
              <span data-id="element-4236" data-mp="2pzz0nxxbi10x">Share updates about your journey.</span>
            </li>
            <li className="flex items-start" data-id="element-4237" data-mp="2uucw20bzc85l">
              <span className="mr-2" data-id="element-4238" data-mp="34oifmyk2ne40">🎉</span>
              <span data-id="element-4239" data-mp="34o8p99v474xs">Celebrate others' wins.</span>
            </li>
            <li className="flex items-start" data-id="element-4240" data-mp="30mnebu2550q8">
              <span className="mr-2" data-id="element-4241" data-mp="30nyihuzi0ahv">🔗</span>
              <span data-id="element-4242" data-mp="2vnkm5a79eozo">Connect people to each other.</span>
            </li>
            <li className="flex items-start" data-id="element-4243" data-mp="2vpx3bl570vbo">
              <span className="mr-2" data-id="element-4244" data-mp="2qnxz691mpudo">📒</span>
              <span data-id="element-4245" data-mp="2qrdencz7t5fm">
                Track relationships (Notion, Airtable, CRM, even your Notes
                app).
              </span>
            </li>
          </ul>
          <p className="font-medium flex items-start" data-id="element-4246" data-mp="2gxmugka4fh5q">
            <span className="mr-2" data-id="element-4247" data-mp="2cxcm50yuwenp">🛠</span>
            <span data-id="element-4248" data-mp="2cy47liyqow09">
              Action: Create your personal "Connection Tracker" — 5 people to
              re-engage with this month.
            </span>
          </p>
        </div>
  }, {
    number: '7️⃣',
    title: 'Your Rules, Your Rhythm',
    content: <div className="space-y-4" data-id="element-4249" data-mp="1y0loox8qtd0q">
          <p data-id="element-4250" data-mp="1y1mwmsugpje8">
            Forget the idea that networking = constant hustle. It's about
            finding your rhythm:
          </p>
          <ul className="space-y-2" data-id="element-4251" data-mp="1nyrefxylg1ci">
            <li data-id="element-4252" data-mp="1suovk6holbqc">
              <strong data-id="element-4253" data-mp="1sugee2eizk9c">Monthly:</strong> New introductions.
            </li>
            <li data-id="element-4254" data-mp="1xu1isscgsktg">
              <strong data-id="element-4255" data-mp="1xvmbsdj4rvp7">Weekly:</strong> Small touchpoints.
            </li>
            <li data-id="element-4256" data-mp="22te2j481hbrt">
              <strong data-id="element-4257" data-mp="22txmsrl5wc90">Daily:</strong> One authentic conversation.
            </li>
          </ul>
          <p className="font-medium flex items-start" data-id="element-4258" data-mp="156ouodqno4y1">
            <span className="mr-2" data-id="element-4259" data-mp="153sz2w2a5scr">📓</span>
            <span data-id="element-4260" data-mp="1a4774e3vt2as">
              Design Your Rhythm: What feels sustainable and energizing for you?
            </span>
          </p>
        </div>
  }];
  return <div className="pt-20" data-id="element-4261" data-mp="1f20bd1lmjm8f">
      <section className="py-16 bg-secondary/5" data-id="element-4262" data-mp="1jujq41w1snet">
        <div className="container mx-auto px-4" data-id="element-4263" data-mp="1jwcz3nu4vjpz">
          <h1 className="text-4xl font-bold text-center text-secondary-dark mb-6" data-id="element-4264" data-mp="mfo001wkivka">
            🌐 The Networking Guide: Build Connections That Matter
          </h1>
          <p className="text-center text-lg text-secondary max-w-3xl mx-auto" data-id="element-4265" data-mp="rcea88loywxs">
            This is not a rulebook. It's a playground for you to explore how you
            connect, what feels authentic, and where you want your network to
            take you.
          </p>
          <p className="text-center text-lg text-secondary max-w-3xl mx-auto mt-4" data-id="element-4266" data-mp="2fkq0kftrztkn">
            You'll find reflection prompts, mini-experiments, and action
            challenges — designed so you shape your own networking style.
          </p>
        </div>
      </section>
      <section className="py-16" data-id="element-4267" data-mp="2kj18um4f9w0r">
        <div className="container mx-auto px-4" data-id="element-4268" data-mp="2khzm3ke1nl37">
          <div className="space-y-12" data-id="element-4269" data-mp="2ya61v5dabq24">
            {steps.map((step, index) => <Card key={index} className="p-6 border-2 border-gray-200" data-id="element-4270" data-mp="2ybh5n56qcxt8" data-mpi={index}>
                <div className="flex flex-col md:flex-row md:items-start gap-4" data-id="element-4271" data-mp="2tb37ceuxl28e">
                  <div className="text-3xl font-bold text-primary" data-id="element-4272" data-mp="388vikutg34gs">
                    {step.number}
                  </div>
                  <div className="flex-1" data-id="element-4273" data-mp="33akbgrujb829">
                    <h2 className="text-2xl font-bold text-secondary-dark mb-4" data-id="element-4274" data-mp="3mtzp3bh166rf">
                      {step.title}
                    </h2>
                    <div className="text-secondary" data-id="element-4275" data-mp="3qvkxajimdwva">{step.content}</div>
                  </div>
                </div>
              </Card>)}
            <Card className="p-6 border-2 border-gray-200" data-id="element-4276" data-mp="3hvg175ivmkwf">
              <h2 className="text-2xl font-bold text-secondary-dark mb-4" data-id="element-4277" data-mp="3htv5hcktsvwz">
                ⚡ Quick Experiments (Choose Your Path)
              </h2>
              <div className="space-y-4" data-id="element-4278" data-mp="37x09p1fxt9me">
                <p className="flex items-start" data-id="element-4279" data-mp="37y1wg36bfkjy">
                  <span className="mr-2 text-xl" data-id="element-4280" data-mp="2u5u5wt5mkptp">🎭</span>
                  <span data-id="element-4281" data-mp="2u7eywecak0pg">
                    <strong data-id="element-4282" data-mp="2u40tex8bzbds">The Actor's Game:</strong> Try introducing yourself
                    3 different ways in one week. Notice what lands.
                  </span>
                </p>
                <p className="flex items-start" data-id="element-4283" data-mp="2k9r1fgnawf3l">
                  <span className="mr-2 text-xl" data-id="element-4284" data-mp="2p70owqr4qgos">📩</span>
                  <span data-id="element-4285" data-mp="2p8lhwbxsprkj">
                    <strong data-id="element-4286" data-mp="1fw2vqmasyyii">The 5-Message Sprint:</strong> Send 5 personalized
                    messages in 5 days. Track replies.
                  </span>
                </p>
                <p className="flex items-start" data-id="element-4287" data-mp="1ktcjzymgh44r">
                  <span className="mr-2 text-xl" data-id="element-4288" data-mp="15zq2tqn30oot">☕</span>
                  <span data-id="element-4289" data-mp="1axj4c6dfwuir">
                    <strong data-id="element-4290" data-mp="1awpyr8q7wb27">The Coffee Challenge:</strong> Book 2 chats with
                    people outside your usual circle this month.
                  </span>
                </p>
              </div>
              <p className="mt-6 font-medium" data-id="element-4291" data-mp="23mggrsuyzx3l">
                👉 By the end of this guide, you don't just "learn how to
                network." You invent your own networking practice — one that
                feels natural, generous, and effective.
              </p>
            </Card>
          </div>
        </div>
      </section>
    </div>;
};